import { isStVersionAtMost, parseStVersion } from './stVersionMet.js'

export default function stMaxVersionMet(stCurrent, stMaxVersion) {
    if (stMaxVersion == null) {
        return true
    }
    return isStVersionAtMost(parseStVersion(stCurrent), parseStVersion(stMaxVersion))
}
